import { TOKEN } from "constants/user";
import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthGuard({ children }: { children?: ReactNode }) {
  const isLoggedIn = !!localStorage.getItem(TOKEN);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/");
    }
  }, []);

  return <>{children}</>;
}
